import React, { useState } from "react";
import { Link } from "react-router-dom";
import './Header.css'; // Import custom CSS for Header

const Header = () => {
  const [search, setSearch] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className="header">
      <div className="header-main">
        {/* Logo Section */}
        <div className="logo">
          <img
            src={require('../assets/image/logo .png')} // Correct path to logo image
            alt="Atlas Trade Center Logo"
            className="logo-image"
          />
        </div>

        {/* Hamburger Menu for Mobile */}
        <div
          className="menu-icon"
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
        >
          <i className={`fa ${menuOpen ? 'fa-times' : 'fa-bars'}`} aria-hidden="true"></i>
        </div>

        {/* Navigation Section */}
        <nav className={`nav ${menuOpen ? 'active' : ''}`}>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/shop">Shop</Link></li>
            <li><Link to="/blog">Blog</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </nav>

        {/* Search Bar */}
        <div className="header-right">
          <div className="search-bar">
            <input
              type="text"
              placeholder="Search..."
              value={search}
              onChange={handleSearchChange}
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

